import { colorTokens } from '../tokens/colors.ts'
import type { TypographyKind } from './types'

// Hard coded colors to be removed when we have the new color tokens in the design system
export const TEXT_COLORS = {
  title: '#1D1B20',
  'body-neutral': '#1E2024',
  'subtext-neutral': '#5A5E68',
  'body-accent': '#413352',
  'subtext-accent': '#7B659F',
  disabled: '#BFBFBF',
  icon: '#5A5555',
  'link-text': '#8E58EF',
  error: colorTokens.semantic.status.error,
  white: colorTokens.global.neutral[500]
} as const

type TextColorKey = keyof typeof TEXT_COLORS

export const resolveColor = (color: string): string => {
  const resolved = TEXT_COLORS[color as TextColorKey]
  if (resolved === undefined) {
    console.warn(
      `resolveColor: unrecognised color "${color}", falling back to body-neutral`
    )
    return TEXT_COLORS['body-neutral']
  }
  return resolved
}

export const resolveDefaultColor = (kind: TypographyKind): string => {
  if (kind === 'heading') {
    return TEXT_COLORS.title
  }
  return TEXT_COLORS['body-neutral']
}
